import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import { isBlank } from 'underscore.string';
export var getCityToDisplay = function getCityToDisplay(location) {
  return (location === null || location === void 0 ? void 0 : location.rootType) === 'locality' && location !== null && location !== void 0 && location.locality ? location === null || location === void 0 ? void 0 : location.locality : location === null || location === void 0 ? void 0 : location.city;
};
export var hasStreetNumber = function hasStreetNumber(address) {
  var re = /^\d+$/;
  return address ? re.test(_.split(address, ' ')[0]) : false;
};
export var convertMetersToMiles = function convertMetersToMiles() {
  var meters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.0;
  return meters * 0.000621371192;
};
export var buildLocationObjectFromGoogle = function buildLocationObjectFromGoogle(data) {
  var findByType = function findByType(components, type) {
    return _.find(components, function (comp) {
      return _.includes(comp.types || [], type);
    });
  };
  return {
    streetNumber: _.get(findByType(data.address_components, 'street_number'), 'short_name'),
    streetName: _.get(findByType(data.address_components, 'route'), 'short_name'),
    ln1: [_.get(findByType(data.address_components, 'street_number'), 'short_name'), _.get(findByType(data.address_components, 'route'), 'short_name')].join(' '),
    ln2: _.get(findByType(data.address_components, 'subpremise'), 'short_name', ''),
    city: _.get(findByType(data.address_components, 'locality'), 'short_name') || _.get(findByType(data.address_components, 'sublocality_level_1'), 'short_name') || _.get(findByType(data.address_components, 'administrative_area_level_3'), 'short_name') || _.get(findByType(data.address_components, 'neighborhood'), 'short_name'),
    county: _.get(findByType(data.address_components, 'administrative_area_level_2'), 'short_name'),
    state: _.get(findByType(data.address_components, 'administrative_area_level_1'), 'short_name'),
    zipcode: _.get(findByType(data.address_components, 'postal_code'), 'short_name'),
    country: _.get(findByType(data.address_components, 'country'), 'long_name')
  };
};
export var formatAddress = function formatAddress(location) {
  var ln1 = location.ln1,
    ln2 = location.ln2,
    city = location.city,
    locality = location.locality,
    state = location.state,
    zipcode = location.zipcode,
    country = location.country;
  var preferredAddressAttributesExist = !_.isEmpty(_.reject([ln1, ln2, city, locality, state, zipcode], isBlank));
  if (!preferredAddressAttributesExist && !isBlank(country)) {
    return country;
  }
  var cityPretty = getCityToDisplay(location);
  return _.reject([_.reject([ln1, ln2], isBlank).join(', '), cityPretty, [state, zipcode].join(' ')], isBlank).join(', ');
};
export var formatAddressForCheckout = function formatAddressForCheckout(_ref) {
  var ln1 = _ref.ln1,
    ln2 = _ref.ln2;
  return _.reject([ln1, ln2], isBlank).join(', ');
};
export var formatAddressShort = function formatAddressShort(location) {
  var ln1 = location.ln1,
    ln2 = location.ln2,
    state = location.state;
  var cityPretty = getCityToDisplay(location);
  var displayFields = !ln1 ? [cityPretty, state] : [ln1, ln2];
  return _.reject(displayFields, isBlank).join(', ');
};

/**
 * Normalizes a stored address so that city reflects locality when available.
 * Fixes stale addresses persisted before the ECOMM-5736 locality fix, where
 * city was set from MapBox's "place" field instead of "locality" (e.g.,
 * "New York" instead of "Brooklyn" for NYC borough addresses).
 * Also updates the formatted `address` and `addressLong` strings to reflect the corrected city.
 */
export var normalizeStoredAddress = function normalizeStoredAddress(address) {
  if (!address || !address.locality || address.city === address.locality) {
    return address;
  }
  var oldCity = address.city,
    correctedCity = address.locality;
  var normalized = _objectSpread(_objectSpread({}, address), {}, {
    city: correctedCity
  });

  // Update the formatted address strings if they contain the old city
  if (normalized.address && oldCity) {
    // Only replaces first occurrence — intentional so state names like "New York" are preserved in addressLong.
    // Known limitation: if oldCity appears in the street name, the street gets modified instead of the city.
    normalized.address = normalized.address.replace(oldCity, correctedCity);
  }
  if (normalized.addressLong && oldCity) {
    normalized.addressLong = normalized.addressLong.replace(oldCity, correctedCity);
  }
  return normalized;
};
export var formatAddressWithoutApt = function formatAddressWithoutApt(_ref2) {
  var ln1 = _ref2.ln1,
    city = _ref2.city,
    state = _ref2.state,
    zipcode = _ref2.zipcode,
    country = _ref2.country;
  var preferredAddressAttributesExist = !_.isEmpty(_.reject([ln1, city, state, zipcode], isBlank));
  if (!preferredAddressAttributesExist && !isBlank(country)) {
    return country;
  }
  return _.reject([_.reject([ln1], isBlank).join(', '), city, [state, zipcode].join(' ')], isBlank).join(', ');
};